<template>
  <div class="loans-pro-item">
    <div class="title">
      {{ safeItem.title }}
      <div class="cancel-btn">
        <a :class="safeItem.status == 0 ? 'data-up' : 'data-down'">{{
          toShowStatstxt(safeItem.status)
        }}</a>
        <a
          style="margin-left: 20px"
          v-if="safeItem.status == 0 && safeItem.type == 1"
          @click="toCancelOrder(safeItem)"
          class="data-down"
          >{{ $t('common.cancel') }}</a
        >
      </div>
    </div>
    <van-row>
      <van-col :span="8">
        <div class="lockming-pro-icon">
          <img :src="safeItem.img" />
        </div>
      </van-col>
      <van-col :span="16">
        <p class="desc">
          {{ $t('loans.orderno') }} : <strong>{{ safeItem.order_num }}</strong>
        </p>
        <p class="desc">
          {{ $t('lockming.stime') }} : {{ safeItem.start_time.split(' ')[0] }}
        </p>
        <p class="desc">
          {{ $t('lockming.etime') }} : {{ safeItem.end_time.split(' ')[0] }}
        </p>
        <p class="desc">
          {{ $t('lockming.nums') }} :
          <span class="data-down"
            >{{ safeItem.amount.toFixed(8) }} {{ safeItem.coin }}</span
          >
        </p>
        <p class="desc">
          {{ $t('lockming.estimation') }} :
          <span class="data-up">
            {{
              (
                (parseFloat(safeItem.amount) *
                  parseFloat(safeItem.interest_rate) *
                  parseFloat(safeItem.days)) /
                100
              ).toFixed(8)
            }}
            {{ safeItem.coin }}
          </span>
        </p>
        <p class="desc">
          {{ $t('lockming.real') }} :
          <span class="data-up"
            >{{ safeItem.total_revenue.toFixed(8) }}
            {{ safeItem.coin }}
          </span>
        </p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  name: 'LockmingOrder',
  props: ['item'],
  computed: {
    safeItem () {
      return this.item || {}
    }
  },
  methods: {
    toShowStatstxt (val) {
      let result = val
      switch (val.toString()) {
        case '0':
          result = this.$t('staking.status0')
          break
        case '1':
          result = this.$t('staking.status1')
          break
        case '2':
          result = this.$t('staking.status2')
          break
      }
      return result
    },
    async toCancelOrder (item) {
      console.log(item)
      Dialog.confirm({
        title: this.$t('member.system_message'),
        message: this.$t('common.confirmtitle') + ' ? ',
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel')
      })
        .then(async () => {
          await this.$http({
            method: 'post',
            url: 'redeemMiningMachine',
            data:{id:item.id}
          }).then(res => {
             this.$toast.success(res.msg);
             this.$emit('reset-data')
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style></style>
